import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import getUsers, { getAllUsers, getUser } from "../queries/getUsers";

export function useGetUser(userId: number) {
  const resultQuery = useQuery([`${URLS.USER_API}/${userId}`], () =>
    getUser(userId)
  );

  return resultQuery;
}

export default function useGetUsers(search: string, page = 1) {
  const resultQuery = useQuery(
    [`${URLS.USER_API}`, {
      params: { search, page }
    }],
    () => getUsers(search, page)
  );

  return resultQuery;
}

export function useGetAllUsers() {
  const resultQuery = useQuery(
    [`${URLS.USER_API}`], getAllUsers);

  return resultQuery;
}
